export const name = 'viewerManagerRuntimeLayoutApi' as const

export const DetachApiSymbol = Symbol('DetachApi')
export const LayoutRuntimeAPISymbol = Symbol('LayoutRuntimeAPI')
